import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import homePage from '../views/homePage.vue'
import listView from '../views/listView.vue'
import detailView from '../views/detailView.vue'
import rightProtection from '../views/rightProtection.vue'
import complainView from '../views/complainView.vue'
import lawyerHome from '../views/lawyerHome.vue'
import queryRight from '../views/queryRight.vue'
import rightApplication from '../views/rightApplication.vue'
import complainApplication from '../views/complainApplication.vue'
import iframeView from '../views/iframeView.vue'
import contactInformation from '../views/contactInformation.vue'
import contactDetail from '../views/contactDetail.vue'
import searchView from '../views/searchView.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: homePage
  },
  {
    path: '/iframeView',
    name: 'iframeView',
    component: iframeView
  },
  {
    path: '/searchView',
    name: 'searchView',
    component: searchView
  },
  {
    path: '/contactDetail',
    name: 'contactDetail',
    component: contactDetail
  },
  {
    path: '/contactInformation',
    name: 'contactInformation',
    component: contactInformation
  },
  {
    path: '/rightApplication',
    name: 'rightApplication',
    component: rightApplication
  },
  {
    path: '/complainApplication',
    name: 'complainApplication',
    component: complainApplication
  },
  {
    path: '/list',
    name: 'list',
    component: listView
  },
  {
    path: '/detail/:entityId',
    name: 'detail',
    component: detailView
  },
  {
    path: '/rightProtection',
    name: 'rightProtection',
    component: rightProtection
  },
  {
    path: '/complainView',
    name: 'complainView',
    component: complainView
  },
  {
    path: '/lawyerHome',
    name: 'lawyerHome',
    component: lawyerHome
  },
  {
    path: '/queryRight',
    name: 'queryRight',
    component: queryRight
  }
]

const router = new VueRouter({
  routes
})

export default router
